<ul class="pagination">
  <li class="pagination-jump pagination-first page-item" *ngIf="boundaryLinks">
    <button
      cignaButton="secondary"
      [disabled]="noPrevious() || disabled"
      (click)="selectPage(1, $event, 'First page')"
      [innerHTML]="firstText"
      aria-label="First page"
      [tabindex]="noPrevious() ? -1 : 0"
      data-test-id="button-first-page"
      data-test="button-first-page"
    ></button>
  </li>

  <li class="pagination-nav pagination-prev page-item" *ngIf="directionLinks">
    <button
      cignaButton="secondary"
      aria-label="Previous page"
      (click)="selectPage(page - 1, $event, 'Previous page')"
      [tabindex]="noPrevious() ? -1 : 0"
      [disabled]="noPrevious() || disabled"
      data-test-id="button-previous-page"
      data-test="button-previous-page"
    >
      <cigna-icon *ngIf="useChevron" type="chevron-left"></cigna-icon>
      <i *ngIf="!useChevron" class="fa fa-arrow-left"></i>
    </button>
  </li>

  <li class="page-count" data-test="page-count" data-test-id="page-count">
    Page {{ page }} of {{ totalPages }}
  </li>

  <li class="pagination-nav pagination-next page-item" *ngIf="directionLinks">
    <button
      cignaButton="secondary"
      aria-label="Next page"
      (click)="selectPage(page + 1, $event, 'Next page')"
      [tabindex]="noNext() ? -1 : 0"
      [disabled]="noNext() || disabled"
      data-test-id="button-next-page"
      data-test="button-next-page"
    >
      <cigna-icon *ngIf="useChevron" type="chevron-right"></cigna-icon>
      <i *ngIf="!useChevron" class="fa fa-arrow-right"></i>
    </button>
  </li>

  <li class="pagination-jump pagination-last page-item" *ngIf="boundaryLinks">
    <button
      cignaButton="secondary"
      [disabled]="noNext() || disabled"
      (click)="selectPage(totalPages, $event, 'Last page')"
      aria-label="Last page"
      [innerHTML]="lastText"
      [tabindex]="noNext() ? -1 : 0"
      data-test-id="button-last-page"
      data-test="button-last-page"
    ></button>
  </li>
</ul>
